// What a lead told us at intake, as clean rows (2026-10-14). One place for the
// slide-over's Veteran snapshot, the Sales Workspace and the Client
// Workspace, so they all read the same.

// leads.leadVaGovAccount (yes | no | unsure), as the forms asked it.
export const VA_GOV_TEXT = { yes: 'Yes', no: 'No', unsure: 'Not sure' };

/**
 * [label, value] rows from the answers our own forms store: the veteran
 * question and rank (website, event, partner page) and the VA.gov answer
 * (every form, and Envoy's push). Rows with no answer are left out.
 */
export const toldUsRows = ({ isVeteran, rank, vaGovAccount }) =>
  [
    [
      'Veteran',
      typeof isVeteran === 'boolean' ? (isVeteran ? 'Yes' : 'No') : null,
    ],
    ['Rank', rank || null],
    ['VA.gov account', VA_GOV_TEXT[vaGovAccount] || null],
  ].filter(([, v]) => v);

/**
 * The note someone actually typed, or null. The website form has no
 * free-text box: its stored note is only its answers joined into a line,
 * which toldUsRows already shows.
 */
export const typedNoteOf = ({ sourceSystem, notes }) =>
  sourceSystem === 'reach-out' ? null : notes || null;
